import axios from 'axios'
import { takeLatest, call, put } from 'redux-saga/effects'
import apiConfig from '@services/apiConfig'
import showToast from '@util/ToastUtil'
import errorHandler from '../errorHandler'
import { UPDATE_BENEFICIARY_PHOTO_IN_STORE } from '@actions/beneficiary'
import {
  UPLOAD_PROFILE_IMAGE, UPDATE_PROFILE_IMAGE, DELETE_PROFILE_IMAGE
} from '@actions/profileImage'

function* upload({ id, file, callback }) {
  try {
    const data = new FormData()
    data.append('file', file)
    const res = yield call(axios, {
      method: 'POST',
      url: `${apiConfig.prefix}/profile-image`,
      params: { id },
      data,
      headers: { 'content-type': 'multipart/form-data' },
    })
    yield put({ type: UPDATE_BENEFICIARY_PHOTO_IN_STORE, beneficiaryId: id, base64: res.data })
    showToast('success', 'Foto cadastrada com sucesso')
    callback && callback(res.data)
  } catch (error) {
    errorHandler(error) // mostra mensagens da ControlID (ex.: Nenhum rosto detectado)
    callback && callback()
  }
}

function* update({ id, file, callback }) {
  try {
    const data = new FormData()
    data.append('file', file)
    const res = yield call(axios, {
      method: 'PUT',
      url: `${apiConfig.prefix}/profile-image`,
      params: { id },
      data,
      headers: { 'content-type': 'multipart/form-data' },
    })
    yield put({ type: UPDATE_BENEFICIARY_PHOTO_IN_STORE, beneficiaryId: id, base64: res.data })
    showToast('success', 'Foto atualizada com sucesso')
    callback && callback(res.data)
  } catch (error) {
    errorHandler(error)
    callback && callback()
  }
}

function* remove({ id, callback }) {
  try {
    yield call(axios, {
      method: 'DELETE',
      url: `${apiConfig.prefix}/profile-image`,
      params: { id },
    })
    yield put({ type: UPDATE_BENEFICIARY_PHOTO_IN_STORE, beneficiaryId: id, base64: null })
    showToast('success', 'Foto removida com sucesso')
    callback && callback()
  } catch (error) {
    errorHandler(error)
    callback && callback()
  }
}

export function* profileImageSaga() {
  yield takeLatest(UPLOAD_PROFILE_IMAGE, upload)
  yield takeLatest(UPDATE_PROFILE_IMAGE, update)
  yield takeLatest(DELETE_PROFILE_IMAGE, remove)
}
